<template>
  <div>
    <b-button-group size="sm">
      <b-button variant="info" @click="info(rowData.id)">Info</b-button>
      <b-button variant="success" @click="editar(rowData.id)">Editar</b-button>
      <b-button variant="danger" @click="borrar(rowData.id)">Borrar</b-button>
    </b-button-group>    
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  Vue.use(VueSweetalert2)
  export default {
    name:'alumnos-actions',
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {      
      editar(id){
        this.$swal('Editar', 'Editando alumno '+ id, 'success')
      },
      borrar(id){
        this.$swal('borrar', 'Borrando alumno '+ id, 'error')
      },
      info(id){
        this.$swal('Info', 'Info alumno '+ id, 'info')
      }
    },    
  }
</script>
